import axios from '@/api/axios'

const createAllUsers = (analytic) => {
  return axios.post('/user-reports', analytic)
}

const getAllUsers = () => {
  return axios.get('/user-reports')
}

const getAllUsersByParams = (params) => {
  return axios.get(`/user-reports${params}`).then((response) => response.data)
}

const getAllUser = (id, params) => {
  return axios.get(`/user-reports/${id}/info`, {params})
}

const updateAllUsers = (id, planInput) => {
  return axios.put(`/user-reports/${id}`, planInput)
}

const deleteAllUsers = (id) => {
  return axios.delete(`/user-reports/${id}`)
}

export default {
  createAllUsers,
  getAllUser,
  getAllUsersByParams,
  getAllUsers,
  updateAllUsers,
  deleteAllUsers,
}
